import React from 'react';
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { GeneralType } from '../../../../types';
import withTheme from '../../utils/styles/theme/withTheme';
import getReadibilityColor from '../../utils/styles/utils/readibility';

type Props = {
  small?: boolean;
  type: GeneralType;

  title?: string;
  description?: string;
};

const AlertWrapper = styled.div<Props>`
  border-left: 3px solid;
  transition: all ease-in-out 0.2s;
  text-align: left;
  &:last-child {
    margin-bottom: 0;
  }

  ${props =>
    props.small
      ? css`
          ul {
            margin-left 15px;
          }
          padding: 10px 20px;
          margin-bottom: 0;
          font-size: 0.8em;
        `
      : css`
          padding: 20px 40px;
          margin-bottom: 32px;
        `}

  background-color: ${({ type, theme: { colors } }) => colors[type].light};
  color: ${({ theme, type }) => getReadibilityColor(theme.colors[type].light, theme)};
  border-color: ${({ type, theme: { colors } }) => colors[type].stain};
`;

const AlertTitle = styled.div<Props>`
  font-weight: bold;
  margin-bottom: 8px;

  color: ${({ theme: { colors }, type }) =>
    type === 'light' ? colors['dark'].stain : colors[type].stain};
`;

const AlertMessage = styled.div<Props>`
  line-height: 2rem;
`;

const Alert: React.FC<Props> = ({
  small,
  type = 'gray',
  title,
  description,
  children,
  ...rest
}) => {
  const parseDescription = content => {
    if (Array.isArray(content)) {
      return `<ul>${content.map(c => `<li>${c}`).join('')}</ul>`;
    }
    return content;
  };
  return (
    <AlertWrapper small={small} type={type} {...rest}>
      {!isEmpty(title) && <AlertTitle type={type}>{title}</AlertTitle>}
      {!isEmpty(description) && (
        <AlertMessage
          type={type}
          dangerouslySetInnerHTML={{ __html: parseDescription(description) }}
        />
      )}
      {children}
    </AlertWrapper>
  );
};

export default withTheme(Alert);
